import hooks from './documents.hooks';

export default (app) => {
  const service = app.service('api/documents');
  service.hooks(hooks);
};
